import { useMemo } from 'react';
import { IAssociationObjectListInfo } from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/AssociationObjectList/AssociationObjectList';
import { IDetailConfig } from '../../../../Types/MasterDetailTypes';
import { internalErrorBusinessComp } from '../../../../Components/InternalError/InternalError';
import { debugStandardDef } from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { NewFormContext } from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import MultiVy from '../../../../Components/MultiVy/MultiVy';

export const debugObjectDetail = (
  association: IAssociationObjectListInfo | null
): IDetailConfig => {
  if (!association) {
    return {
      comp: internalErrorBusinessComp(
        '547efbf9-39a1-4abc-afe9-951ebfa17428',
        'collection saknas'
      ) as IDetailConfig['comp'],
      caption: 'collection saknas',
      fullPage: true,
    };
  }
  return {
    comp: () => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const Comp = useMemo(
        () => debugStandardDef.def(association.collection).comp,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [association.collection]
      );
      return (
        <NewFormContext>
          <MultiVy
            tabbed
            vyProps={{ id: association.id, config: { parents: [] } }}
            vyer={[
              {
                caption: association.association.DisplayLabel,
                comp: Comp,
                collectionName:
                  association.association.AssociatedCollectionName,
              },
            ]}
          />
        </NewFormContext>
      );
    },
    caption: association.association.AssociationName,
  };
};
